import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography, Button} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, CheckCircle as CaseResolvedIcon} from "@mui/icons-material"
import {useNavigate} from "react-router-dom"

import {CustomerCaseResolvedActivityPayload} from "@indebted/api"

function CaseResolvedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerCaseResolvedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
	customerID: string,
) {
	const navigate = useNavigate()

	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<CaseResolvedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Case Type:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.CaseType}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Resolution:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Resolution}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Resolved By:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.ResolverName || Payload.ResolverType}
							</Typography>
						</div>
						{Payload.ResolverEmail && (
							<div>
								<Typography className={classes.activityContentLabel}>Agent Email:</Typography>
								<Typography className={classes.activityContentValue}>
									{Payload.ResolverEmail}
								</Typography>
							</div>
						)}
						<div>
							<Button
								size="small"
								variant="outlined"
								onClick={() => navigate(`/customers/${customerID}/cases?CaseID=${Payload.CaseID}`)}
								sx={{textTransform: "none", fontSize: "0.75rem", fontWeight: 600}}
							>
								See Case
							</Button>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {CaseResolvedActivity}
